import { checkCRUDAccess } from "utils/crudSagaHelper";
import { MODULE_AI_CHAT } from "variables/modules";

// Single source of truth for "may this user see the AI chat bubble".
// Delegates to the app-wide access check (which already bypasses super admins).
export function canUseAiChat(user, modules) {
  if (!user) return false;
  return checkCRUDAccess(modules, MODULE_AI_CHAT, "view", user);
}

export default canUseAiChat;
